import { useLoaderData } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LectureViewWithPermission } from "./lectureViewWithPermission";
import { LectureViewWithoutPermission } from "./lectureViewWithoutPermission";
import { CourseSidebarWithoutPermission } from "./courseSidebarWithoutPermission";
import { CourseSidebarWithPermission } from "./courseSidebarWithPermission";
import { LectureLoaderData } from "../loaders/lectureLoaderType";
import {
  CourseSidebarLecture,
  CourseSidebarSection,
} from "../types/lectureTypes";

export function LectureLayout() {
  const { t } = useTranslation();
  const data = useLoaderData() as LectureLoaderData;
  const {
    lectureId,
    lectureContent,
    courseSidebar,
    bookmarkContents,
    hasFullAccess,
  } = data;

  const currentLecture = courseSidebar.sections
    .flatMap((section) => section.lectures)
    .find((lecture) => lecture.id === lectureId) as CourseSidebarLecture;
  const currentSection = courseSidebar.sections.find(
    (section) => section.id === lectureContent.sectionId,
  ) as CourseSidebarSection;
  if (!currentSection) {
    throw Error(t("lecture.errors.sectionNotFound"));
  }

  const isThereAnyLectureLeftInTheSection =
    currentSection.lectures.length > currentLecture.orderNumber + 1;
  let nextLecture: CourseSidebarLecture | null;
  if (isThereAnyLectureLeftInTheSection) {
    const nextLectureOrderNumber = currentLecture.orderNumber + 1;
    nextLecture = currentSection.lectures[nextLectureOrderNumber];
  } else {
    const nextSectionOrderNumber = currentSection.orderNumber + 1;
    if (nextSectionOrderNumber >= courseSidebar.sections.length) {
      nextLecture = null;
    } else {
      nextLecture = courseSidebar.sections[nextSectionOrderNumber].lectures[0];
    }
  }
  // Kullanıcının içeriğe erişimi var mı kontrol et
  // hasFullAccess: Kullanıcı kursu satın almış
  // lectureContent.isPublic: Ders genel erişime açık
  const canAccessContent = hasFullAccess || lectureContent.isPublic;

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      {/* Ana Content Alanı */}
      <div className="flex-1 overflow-hidden">
        {canAccessContent ? (
          <LectureViewWithPermission
            key={lectureId}
            nextLecture={nextLecture}
            content={lectureContent}
            htmlContentPromise={data.htmlContent}
            lectureId={lectureId}
            hasFullAccess={hasFullAccess}
            isCompleted={currentLecture.isCompleted || false}
            bookmarkContents={bookmarkContents ?? []}
            courseProgress={courseSidebar.courseProgress || null}
          />
        ) : (
          <LectureViewWithoutPermission content={lectureContent} />
        )}
      </div>

      {/* Sidebar - Access durumuna göre */}
      <div className="w-80 border-l border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 overflow-hidden">
        {hasFullAccess ? (
          <CourseSidebarWithPermission
            courseSidebar={courseSidebar}
            currentLectureId={lectureId}
            isCompleted={currentLecture?.isCompleted || false}
          />
        ) : (
          <CourseSidebarWithoutPermission
            sidebar={courseSidebar}
            currentLectureId={lectureId}
          />
        )}
      </div>
    </div>
  );
}
